// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2-s6H","colMin":"styles_colMin__o1LWr","colCheckbox":"styles_colCheckbox__1Acgl"};